import type { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthManager } from '@izimi/auth';
import config, { appSpec } from 'core/config';
import { Routes } from 'navigation/types';

import { usePortalConfiguration } from '../modules';

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const { configuration } = usePortalConfiguration();
  const navigate = useNavigate();

  const postLogoutRedirectUrl = window.location.origin + Routes.LogoutSuccess;

  const onSigninCallback = async () => {
    return navigate(Routes.AuthenticationMethodSelection, { replace: true });
  };

  return (
    <AuthManager
      apiUrl={config.apiUrl}
      authenticationProviders={configuration?.authenticationProviders}
      onSigninCallback={onSigninCallback}
      postLogoutRedirectUrl={postLogoutRedirectUrl}
      loadUserInfo={false}
      appSpec={appSpec}>
      {children}
    </AuthManager>
  );
};
